import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moneyFormatter from 'helpers/money-formatter';
import { TruncateToolTip } from 'Components';
import Footer from './InvoicesPaymentConfirmationTemplateFooter';
import './InvoicesPaymentConfirmationTemplate.css';

const InvoicesPaymentConfirmationTemplate = ({
  InvoiceNumber,
  POAFENumber,
  ProjectNumber,
  Total,
  AmountRemaining,
}) => {
  const formatRow = (key, value = '') => {
    if (key === 'POAFENumber' || key === 'ProjectNumber') {
      let formattedValue = value;
      if (value.split(',').includes(i18n.t('common:Not Specified'))) {
        formattedValue = value
          .split(',')
          .filter(item => item !== i18n.t('common:Not Specified'))
          .join(',');
      }

      return <TruncateToolTip text={formattedValue} delimiter="," />;
    }

    return value;
  };


  return (
    <tr>
      <td>{InvoiceNumber}</td>
      <td>{formatRow('POAFENumber', POAFENumber)}</td>
      <td>{formatRow('ProjectNumber', ProjectNumber)}</td>
      <td className="invoices-payment-confirmation-table__footer__amount--align-right">
        {moneyFormatter(Total)}
      </td>
      <td className="invoices-payment-confirmation-table__footer__amount--align-right">
        {moneyFormatter(AmountRemaining)}
      </td>
    </tr>
  );
};

InvoicesPaymentConfirmationTemplate.propTypes = {
  InvoiceNumber: PropTypes.string,
  POAFENumber: PropTypes.string,
  ProjectNumber: PropTypes.string,
  Total: PropTypes.number,
  AmountRemaining: PropTypes.number,
};

InvoicesPaymentConfirmationTemplate.Footer = Footer;

export default InvoicesPaymentConfirmationTemplate;



// WEBPACK FOOTER //
// ./src/components/InvoicesPaymentConfirmationTemplate/InvoicesPaymentConfirmationTemplate.jsx